import React from 'react';
import { usd, fmtDate, activityLabel } from '../utils/format';

export default function Activity({ data }) {
  const acts = (data.activities || []).slice().reverse(); // newest first

  return (
    <div className="tab fade-in">
      <div className="section-title"><span className="bar" />Transaction History</div>
      <div className="card">
        {acts.length ? (
          acts.map((a, i) => {
            const type = Number(a.activityType);
            const isOut = type === 8; // withdrawal
            return (
              <div className="act-row" key={i}>
                <div className="act-ic">{iconFor(type)}</div>
                <div className="act-meta">
                  <div className="act-title">{activityLabel(type)}</div>
                  <div className="act-sub">
                    {fmtDate(a.timestamp)}
                    {Number(a.packageId) > 0 ? ` · PKG ${Number(a.packageId)}` : ''}
                    {Number(a.fromId) > 0 ? ` · from #${Number(a.fromId)}` : ''}
                  </div>
                </div>
                <div className="act-amt" style={{ color: isOut ? 'var(--blue-1)' : 'var(--gold-2)' }}>
                  {isOut ? '-' : '+'}{usd(a.amount)}
                </div>
              </div>
            );
          })
        ) : (
          <div className="empty">No activity yet.</div>
        )}
      </div>
    </div>
  );
}

function iconFor(type) {
  switch (type) {
    case 0: return '🚀';
    case 1: return '⬆️';
    case 2: return '🤝';
    case 3: return '📶';
    case 4: case 5: case 6: case 7: return '🏆';
    case 8: return '💸';
    case 9: return '♻️';
    case 10: return '⭐';
    default: return '•';
  }
}
